import { FC } from 'react';

import Form from '@/shared/components/forms/PlatformForm';
import PlatformSelect from '@/shared/components/forms/PlatformSelect';

interface KeywordsProps {
    filters: Record<string, unknown>;
    handleChange: (path: string[], value: unknown) => void;
}

const Keywords: FC<KeywordsProps> = ({ filters, handleChange }): JSX.Element => (
    <Form>
        <Form.Item label='Keywords' style={{ marginBottom: 0 }}>
            <PlatformSelect
                allowClear
                mode='tags'
                onChange={(value) => handleChange(['keywords'], value)}
                placeholder='Add Keywords...'
                style={{ width: '100%' }}
                value={Array.isArray(filters.keywords) ? filters.keywords.map(String) : []}
            />
        </Form.Item>
    </Form>
);

export default Keywords;
